export default "__VITE_ASSET__BF7B0npu__"